import { useState } from 'react'
import { useRequest, useView } from '@10000/react'
import { QuestionOrder, SquizScreen, usePracticeWheel } from '../common'
import { Body, Box, Button, Checkbox, Dialog, H2, H4 } from '../../widgets'
import { questions } from '../../../lookups'
import { useBackground, useShell } from '../../layout'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import './Question.scss'

export const Question = ({ active, displayMode }) => {
  const request = useRequest('squiz')
  const { hide } = usePracticeWheel()
  const { presenter, question, questionIndex, options, hideSkipConfirmations, teamAverages } = useView('squiz')
  const { questionCount } = options || {}
  const [checkSkipOpen, setCheckSkipOpen] = useState(false)
  const [doNotShowAgain, setDoNotShowAgain] = useState(false)

  const questionsAnswered = teamAverages.some(x => x !== null)
  const canSkip = questionIndex < (questionCount - 1) || questionsAnswered

  const onStart = () => request('questionStarted')
  const onSkip = () => request('questionSkipped', { hideSkipConfirmations: doNotShowAgain }).then(() => setCheckSkipOpen(false))

  useBackground().set(mobile => ({
    active,
    background: 1,
    position: mobile ? 'left -756px top -472px' : 'left -316px top -710px',
    size: '2072px 2034px',
    fade: true
  }))

  useShell({
    active,
    mode: 'squiz',
    step: questionIndex + 1,
    max: questionCount
  })

  useGSAP(() => {
    gsap.timeline()
      .call(hide)
      .to('h4', { opacity: 1, duration: 0.5 })
      .to('h2', { opacity: 1, duration: 0.5 }, '<')
  })

  const handleSkip = () => {
    if(hideSkipConfirmations) {
      onSkip()
    } else {
      setCheckSkipOpen(true)
    }
  }

  return (
    <SquizScreen>
      {(!presenter || displayMode) && (
        <Box justifyContent="center" alignItems="center" fullHeight>
          <H4 className="blink" align="center" opacity={0} color="white">
            Waiting for host...
          </H4>
        </Box>
      )}

      {presenter && (
        <>
          <Box grow justifyContent="center" alignItems="center">
            <H2 className="question-title" align="center" opacity={0} color="white">
              {questions[question]?.question}
            </H2>
          </Box>

          <Box fullWidth gap={8}>
            <Button fullWidth onClick={onStart}>
              Start
            </Button>
            <Button onClick={handleSkip} disabled={!canSkip}>
              Skip
            </Button>

            <Box justifyContent="center" alignItems="center">
              <QuestionOrder />
            </Box>
          </Box>
        </>
      )}

      <Dialog
        open={checkSkipOpen}
        onClose={() => setCheckSkipOpen(false)}
        mobileDrawer={false}
        showControls={false}
        mobileBackground="white"
      >
        <Box column gap={16} fullWidth>
          <H4 fullWidth align="left" className="exit-text">
            Are you sure?
          </H4>
          <Body fullWidth align="left" color="black">Once you skip a question you won&apos;t be able to go back.</Body>
        </Box>

        <Box fullWidth className="check-skip-dialog">
          <Box alignItems="center" gap={8} onClick={() => setDoNotShowAgain(!doNotShowAgain)}>
            <Checkbox dark checked={doNotShowAgain} />
            <Body color="black">
              Don&apos;t show me again
            </Body>
          </Box>
          <Button light onClick={() => setCheckSkipOpen(false)} style={{ border: 'solid 1px black' }}>Cancel</Button>
          <Button onClick={onSkip}>Skip</Button>
        </Box>
      </Dialog>
    </SquizScreen>
  )
}